<template>
<div class="box-labourParticulars">
    <div class="nav">
        <router-link to="Appendix"><img src="../../assets/up.png" alt="" class="upClass"></router-link>
        <div v-if="typeShow">邮件书写规范及收件人检索操作示例</div>
        <div v-if="flowShow || agreementShow">员工报班优惠制度</div>
        <div v-if="agreementShow1 || agreementShow2">伯乐奖执行办法</div>
        <div v-if="agreementShow3">合同附加条款</div>
        <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
    </div>
    <div class="labourParticulars" v-if="typeShow">
        <h4 class="labourParticulars-title labourParticulars-title-active">书写规范</h4>
        <p class="labourParticulars-title-content-active">1. 邮件应写清邮件主题，根据具体情况请添加相关附件，正文请写明称呼、目的以及落款签名。</p>
        <span class="labourParticulars-title-content-active">(1) 主题：邮件主题请简单清晰概括邮件主旨，请务必添加。</span>
        <span class="labourParticulars-title-content-active">(2) 正文：请一定先写称呼，有头有尾，不建议使用任何表情符号；如有附件可点击【附件文件】上传。</span>
        <span class="labourParticulars-title-content-active">(3) 签名：可设置自己的固定签名。</span>
        <p class="labourParticulars-title-content-active">2. 邮件收件人是接收邮件的主要对象，抄送人为需要了解邮件正文内容的相关人员。</p>
    </div>
    <div class="labourParticulars" v-if="flowShow">
        <h4 class="labourParticulars-title labourParticulars-title-active" id="titleText">员工优惠报名的适用范围</h4>
        <span class="spanClass labourParticulars-title-content-active">已经转正的全日制劳动合同教职员工和已经纳入正式员工管理或入职满 6 个月以上的劳务合同教职员工、非全日制劳动合同教职员工。</span>
    </div>
    <div class="labourParticulars" v-if="agreementShow">
        <h4 class="labourParticulars-title labourParticulars-title-active" id="titleText">员工优惠报名注意事项</h4>
        <span class="spanClass labourParticulars-title-content-active">在不影响员工日常工作的前提下，员工本人在业余时间可参加学习，需经其直接上级及部门总监审批同意后再经本机构人力资源部根据业务工作淡旺季统筹安排。严禁弄虚作假虚构报名，如发现员工弄虚作假或在优惠报名后转让听课证等情况，视为违纪行为，一律取消该员工当年及下一年优惠报名的资格，予以通报批评，并由该员工赔偿由此给学校带来的损失。</span>
    </div>
    <div class="labourParticulars" v-if="agreementShow1">
        <h4 class="labourParticulars-title labourParticulars-title-active">“伯乐奖”推荐流程</h4>
        <p class="labourParticulars-title-content-active" id="textTitleContent">1. 推荐者将被推荐人简历发送至人力部门邮箱pengkun4@xdf.cn，并附正文说明。</p>
        <p class="labourParticulars-title-content-active" id="textTitleContent">2. 人力部门招聘专员对被推荐者进行资格审查、简历筛选。</p>
        <p class="labourParticulars-title-content-active" id="textTitleContent">3. 人力部门招聘专员对被推荐者进行电话邀约、现场面试。</p>
        <p class="labourParticulars-title-content-active" id="textTitleContent">4. 被推荐人最后成功入职，即认定为推荐人获得伯乐奖领取奖金资格。</p>
    </div>
    <div class="labourParticulars" v-if="agreementShow2">
        <h4 class="labourParticulars-title labourParticulars-title-active">“伯乐奖”领取流程</h4>
        <p class="labourParticulars-title-content-active" id="textTitleContent">1. 每月由人力部门招聘专员汇总制作《人才推荐奖励汇总表》。</p>
        <p class="labourParticulars-title-content-active" id="textTitleContent">2. 每月由人力部门招聘专员发送邮件至各推荐人，并附件《人才推荐奖励汇总表》，明确各被推荐人情况。</p>
        <p class="labourParticulars-title-content-active" id="textTitleContent">3. 待被推荐人成功入职后，人力部门招聘专员定期组织奖金发放活动，以邮件及电话的方式通知推荐人领取奖金的时间及地点，注意金额会合并工资计税。</p>
    </div>
    <div class="labourParticulars" v-if="agreementShow3">
        <img src="../../assets/19.jpg" alt="" class="img">
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            typeShow: false,
            flowShow: false,
            agreementShow: false,
            agreementShow1: false,
            agreementShow2: false,
            agreementShow3: false,
        }
    },
    methods: {
        fn() {
            var code = this.$route.params.code
            if (code == 12) {
                this.typeShow = true
            } else if (code == 13) {
                this.flowShow = true
            } else if (code == 14) {
                this.agreementShow = true
            } else if (code == 15) {
                this.agreementShow1 = true
            } else if (code == 16) {
                this.agreementShow2 = true
            } else if (code == 17) {
                this.agreementShow3 = true
            }
        },
        getOnPage() {
            this.$router.push({
                name: 'Search',
                params: {
                    code: "3"
                }
            })
        },
    },
    mounted() {
        this.fn()
    }
};
</script>

<style>
.box-labourParticulars {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
}

.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.labourParticulars {
    width: 90%;
    height: 83%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.5);
    border-radius: 11px;
    padding-top: 5%;
}

.labourParticulars .labourParticulars-title {
    text-align: center;
    font-weight: 600;
}

.labourParticulars .labourParticulars-hw {
    margin-bottom: 20px;
}

.labourParticulars p {
    color: #696969;
    font-size: 16px;
    margin: 25px 16px 0;
}

.labourParticulars span {
    display: block;
    line-height: 30px;
    margin: 10px 16px 0 16px;
    color: #888787;
    font-size: 15px;
    text-indent: 30px;
}
.img{
    display: block;
    width: 90%;
    height: 98%;
    margin: 0 auto;
}
.labourParticulars-title-active {
    font-size: 16px
}
.labourParticulars-title-content-active {
    letter-spacing:2px;
    line-height: 30px;
}
#textTitleContent {
    color: #888787;
    font-size: 14px;
}
#titleText {
    margin-bottom: 20px
}
</style>



// WEBPACK FOOTER //
// src/components/Appendix/appendix1.vue